import { render, staticRenderFns } from "./ChatParticipantMediaMessage.vue?vue&type=template&id=8fa1eb90&scoped=true"
import script from "./ChatParticipantMediaMessage.vue?vue&type=script&lang=js"
export * from "./ChatParticipantMediaMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatParticipantMediaMessage.vue?vue&type=style&index=0&id=8fa1eb90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa1eb90",
  null
  
)

export default component.exports